import React from 'react';
import { Helmet } from "react-helmet-async";
import HeaderFour from '../../components/Header/HeaderFour';
import FooterTwo from '../../components/Footer/FooterTwo';
import Breadcrumb from '../../components/Breadcrumb';
import SectionTitle from '../../components/SectionTitle';
import SingleTeamThree from '../../components/Team/SingleTeamThree';
import shapeImg from '../../assets/img/contact/international-Schools.jpg';
import shapeImg2 from '../../assets/img/contact/CBSE-Schools.jpg';
import shapeImg3 from '../../assets/img/contact/ICSE-Schools.jpg';
import shapeImg4 from '../../assets/img/contact/distributors.jpg';
import shapeImg5 from '../../assets/img/contact/Stationery-distributors.jpg';

import teamImg1 from '../../assets/img/team/team-4-1.jpg';
import teamImg2 from '../../assets/img/team/team-4-2.jpg';
import teamImg3 from '../../assets/img/team/team-4-3.jpg';
import teamImg4 from '../../assets/img/team/team-4-4.jpg';
import teamImg5 from '../../assets/img/team/team-4-5.jpg';
import teamImg6 from '../../assets/img/team/team-4-6.jpg';
import teamImg7 from '../../assets/img/team/team-4-7.jpg';
import teamImg8 from '../../assets/img/team/team-4-8.jpg';

const Clients = () => {
  return (
    <main>
      <Helmet>
      <title>Our School Clients | CBS HUB Serves 450+ Schools Across India | Central Books</title>
      <meta name="description" content="CBS HUB (Central Books) serves 450+ CBSE, ICSE & State Board schools and 9 million+ students across Hyderabad, Telangana, AP & Pan-India with B2B educational supplies." />
      <meta name="keywords" content="Central Books school clients, CBS HUB partner schools, 450 schools Hyderabad, B2B school supplier clients India, CBSE ICSE school partners Telangana" />
      <link rel="canonical" href="https://www.centralbooks.in/clients" />
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content="Our School Clients | CBS HUB Serves 450+ Schools Across India | Central Books" />
      <meta property="og:description" content="CBS HUB (Central Books) serves 450+ CBSE, ICSE & State Board schools and 9 million+ students across Hyderabad, Telangana, AP & Pan-India with B2B educational supplies." />
      <meta property="og:url" content="https://www.centralbooks.in/clients" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.centralbooks.in/images/clients-og.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Our School Clients | CBS HUB Serves 450+ Schools Across India | Central Books" />
      <meta name="twitter:description" content="CBS HUB (Central Books) serves 450+ CBSE, ICSE & State Board schools and 9 million+ students across Hyderabad, Telangana, AP & Pan-India with B2B educational supplies." />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.centralbooks.in/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Our Clients",
              "item": "https://www.centralbooks.in/clients"
            }
          ]
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "CBS HUB School Client Network",
          "description": "450+ schools served across India by CBS HUB Private Limited",
          "numberOfItems": 450
        })}
      </script>
    </Helmet>
      <HeaderFour />
      <Breadcrumb title="450+ Schools Trust CBS HUB as Their B2B Supply Partner" />
      <div className="ed-team-area p-relative inner-style fix z-index pt-110 pb-90">
        <div className="container">
          <div className="it-team-title-wrap mb-40">
            <div className="row align-items-center justify-content-center text-center mb-50">
              <div className="col-xl-10">
                <h2 className="pb-20" style={{ fontSize: '2.2rem', fontWeight: '700' }}>CBSE, ICSE & State Board School Partners Across India</h2>
                <h3 className="pb-30" style={{ color: '#ea580c', fontSize: '1.6rem', fontWeight: '600' }}>From Hyderabad to Pan-India — Our Growing School Network</h3>
                <p className="lead" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#374151' }}>
                  CBS HUB Private Limited (Central Books) proudly serves 450+ CBSE, ICSE, IGCSE and State Board schools across Hyderabad, Telangana, Andhra Pradesh and Pan-India — delivering books, kits, stationery, notebooks and library solutions to over 9 million students each academic year.
                </p>
              </div>
            </div>
            <div className="row align-items-center justify-content-center">
              <div className="col-xl-10">
                <h4 className="pt-20">International Schools</h4>
              <img src={shapeImg} alt="" />
              <h4 className="pt-30">CBSE Schools</h4>
              <img src={shapeImg2} alt="" />
              <h4 className="pt-30">ICSE Schools</h4>
              <img src={shapeImg3} alt="" />
              <h4 className="pt-30">Distributors for..</h4>
              <img src={shapeImg4} alt="" />
              <h4 className="pt-30">Stationery Distributors for..</h4>
              <img src={shapeImg5} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterTwo />
    </main>
  );
};
export default Clients;